
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foam/login",
      function () {
        return require("private-next-pages/foam/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foam/login"])
      });
    }
  